var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiReplyAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_202_1516)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8724 9.39453V5.44092L17.7913 12.3597L10.8724 19.2786V15.2261C5.93043 15.2261 2.47102 16.8076 9.53674e-06 20.267C0.988413 15.3249 3.95362 10.3829 10.8724 9.39453ZM16.8029 8.40613V5.44092L23.7217 12.3597L16.8029 19.2786V16.3134L20.7565 12.3597L16.8029 8.40613Z",
    className: "svgFill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_202_1516"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.7217,
    height: 23.7217,
    fill: "white",
    transform: "matrix(-1 0 0 1 23.7217 0.499023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiReplyAll);
export default __webpack_public_path__ + "static/media/mdi_reply-all.fd3e96be41efea567f80e2d83936f5e8.svg";
export { ForwardRef as ReactComponent };